import { poll } from '@lower-financial/toolbox';
import { useAnalytics } from '@lower-financial/analytics';
import { JumpstartEligibility, JumpstartEligibilityStatus } from '@lower-financial/lending-web-api/generated';
import { getJumpstartEligibility, JumpstartEligibilityResponse } from '@lightspeed/api/services/backend/lending/getJumpstartEligibility';

const checkEligibility = async (quotingApplicationSubmissionId: string): Promise<JumpstartEligibility> => {
  const response: JumpstartEligibilityResponse = await getJumpstartEligibility(quotingApplicationSubmissionId);

  if (response.status === 200) {
    return response.json();
  }

  // allow user to continue even if the jumpstart eligibility check fails
  return {
    isBorrowerCreditFrozen: false,
    leadScore: null,
    reason: 'An error occurred while checking jumpstart eligibility.',
    status: JumpstartEligibilityStatus.ManualIntervention,
  };
};

const checkForPollingComplete = (response: {
  status: string | null
}) => response.status !== null && response.status !== JumpstartEligibilityStatus.InProgress;

export const pollForJumpstartEligibility = async (
  quotingApplicationSubmissionId: string,
  fireAnalyticsEvent: ReturnType<typeof useAnalytics>,
) => {
  const getEligibility = () => checkEligibility(quotingApplicationSubmissionId);
  const pollIntervalInMilliseconds = 2000;
  const pollTimeoutInMilliseconds = 15000;

  const pollResult = await poll(
    getEligibility,
    checkForPollingComplete,
    pollIntervalInMilliseconds,
    pollTimeoutInMilliseconds,
    () => fireAnalyticsEvent('polling_for_jumpstart_eligibility_timeout'),
  );

  return pollResult;
};
